import React from 'react';
import {FormGroup, InputGroup} from 'react-bootstrap';
import Select from 'react-select';
import FontAwesome from 'react-fontawesome';
import {connect} from 'react-redux';
import {setOption} from './FormAction';
import SWTNewColorModal from '../../../view/workdoc/SWTNewColorModal';
// import WorkdocStore from '../../../stores/WorkdocStore';

class SelectColor extends React.Component {

  constructor(...args) {
    super(...args);
    this.initial();
    this.state = {
      modal: false,
    };
  }

  initial() {

  }

  onFormChange = (e) => {
    // {
    //   series_id: e.value,
    //       series: e.label,
    // }
    const {uiSchema} = this.props
    const multi = (uiSchema['ui:multi']!==undefined)?uiSchema['ui:multi']:false
    let evalue = multi?e:e.value;
    this.props.onChange(evalue);
  };

  renderOption = (option) => {
    return (
        <span><img
            alt=''
            src={'https://demo2.bigfix.co/korat/img/car_color/' +
                 option.value.toUpperCase() +
                 '-32x32.png'} /> {option.label}</span>
    );
  };

  openModal = () => {
    this.setState({modal: true});
  };

  closeModal = () => {
    this.setState({modal: false});
  };

  render() {
    const {
      store,
      formData,
      uiSchema
    } = this.props;
    const multi = (uiSchema['ui:multi']!==undefined)?uiSchema['ui:multi']:false
    return (
        <FormGroup>
          <InputGroup>
            <Select
                multi={multi}
                removeSelected={true}
                readOnly={this.props.readonly}
                disabled={this.props.disabled}
                placeholder={'โปรดระบุ'}
                clearable={false}
                value={formData}
                options={store.options.color_options}
                onChange={this.onFormChange}
                valueRenderer={this.renderOption}
                optionRenderer={this.renderOption}
            >
            </Select>
            <InputGroup.Addon
                readOnly={this.props.readonly}
                disabled={this.props.disabled}
                className="btn"
                onClick={this.openModal}
            >
              <FontAwesome name="plus" />
            </InputGroup.Addon>
          </InputGroup>

          <SWTNewColorModal ref={'newColorPop'}
                            show={this.state.modal}
                            onChange={this.closeModal}
                            onHide={this.closeModal} />
        </FormGroup>
    );
  }
};

const mapStateToProps = (state) => ({
  store: state,
});

const mapDispatchToProps = ({
  setOption,
});

const SelectCarContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SelectColor);

export default SelectCarContainer;



// WEBPACK FOOTER //
// ./src/component/element/workdoc/SelectColor.js